import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Column, Row } from '@prisjakt/ui/list/variants';
import { H3Text, BodyMediumText } from '@prisjakt/ui/text/variants';
import { DAILY_DEALS_ID } from '../../../../globals/helpers/campaign/campaign-ids';

import CampaignLink from '../link';
import { CampaignGraphic } from './styles';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

const formatDates = (campaign, translationCode, timeZone) => {
  const start = new Date(parseInt(campaign.start, 10));
  const end = new Date(parseInt(campaign.end, 10));
  const locale = translationCode.replace('_', '-').toLowerCase();
  const localeOptions = { month: 'long', day: 'numeric', timeZone };
  const startDate = start.toLocaleString(locale, localeOptions);
  const endDate = end.toLocaleString(locale, localeOptions);
  return startDate === endDate ? startDate : `${startDate} - ${endDate}`;
};

const ThemeListItem = ({ campaign, translation, timezone }) =>
  campaign ? (
    <Row gap={1} style={{ flexWrap: 'wrap' }}>
      <CampaignLink
        campaign={campaign}
        linkContent={
          <CampaignGraphic
            src={campaign.media.images.featured}
            alt={campaign.title.short}
          />
        }
        onClick={() =>
          trackInternalNavigationClick({
            scope: InternalNavigationScope.CAMPAIGN_GO_TO,
            nextPage: campaign.web_uri.responsive,
          })
        }
      />
      <Column>
        <CampaignLink
          campaign={campaign}
          linkContent={
            <>
              <H3Text>{campaign.title.short}</H3Text>
              <BodyMediumText container="p">
                {campaign.description.short}
              </BodyMediumText>
            </>
          }
          onClick={() =>
            trackInternalNavigationClick({
              scope: InternalNavigationScope.CAMPAIGN_GO_TO,
              nextPage: campaign.web_uri.responsive,
            })
          }
        />
        {campaign.id !== DAILY_DEALS_ID && (
          <BodyMediumText container="p">
            {formatDates(campaign, translation, timezone)}
          </BodyMediumText>
        )}
      </Column>
    </Row>
  ) : null;

const { shape, string } = PropTypes;

ThemeListItem.propTypes = {
  campaign: shape({
    title: shape({
      short: string,
    }),
    description: shape({
      short: string,
    }),
  }).isRequired,
  translation: string.isRequired,
  timezone: string.isRequired,
};

export default connect(state => ({
  translation: state.areas.campaign.translation,
  timezone: state.areas.campaign.timezone,
}))(ThemeListItem);
